import 'jquery-ajax-unobtrusive';
import '../../../scss/sites/default/default-style.scss';
import Header from '@png/npm-header';
import Bookingmask from '@png/npm-bookingmask';
import SvgIcon from '../../modules/svg-icon';
import AddressLookup from '../../modules/geolocate';
import Incrementer from '../../modules/incrementer';
import SelectDropdown from '../../modules/select-dropdown';
import Sticky from '../../modules/sticky';
import Toast from '../../modules/toast';
import RealTimePrice from '../../modules/catalog/realtime-price';
import RealTimeStock from '../../modules/real-time-stock';
import SmoothScroll from '../../modules/smooth-scroll';
import Categories from '../../modules/categories';
import Recaptcha from '../../modules/recaptcha';

document.addEventListener('DOMContentLoaded', () => {
  // Svg icons
  new SvgIcon().init();

  // Header
  new Header({
    desktopMenuBreakpoint: 992,
    openUrlOnToggle: false
  }).init();

  // Address lookup
  new AddressLookup().init();

  // Incrementer
  new Incrementer().init();

  // Bookingmask
  new Bookingmask({
    displayFormat: 'd/m/Y',
    dateFormat: 'd-m-Y',
    datepickerType: 'separate',
    disableMobile: false
  }).init();

  // Select dropdown
  new SelectDropdown().init();

  // Sticky
  new Sticky({
    stickyElement: document.querySelector('[data-module="Header"]')
  }).init();

  // Toast
  new Toast({
    duration: 3000,
    close: true
  }).init();

  // Real time price
  new RealTimePrice().init();

  // Real time stock
  new RealTimeStock().init();

  new Recaptcha().init();

  // Smooth scroll
  new SmoothScroll().init();

  // Categories
  new Categories().init();
});
